module.exports = __webpack_public_path__ + "img/home_banners.179ee6ab.png";